import { useEffect, useState, useRef } from "react";

export default function SurveyTimer({
  totalSeconds = 0, //  NOW COMES DIRECTLY IN SECONDS
  initialSeconds = null, // remaining seconds when resuming
  onTimeUpdate,
  onFinish,
}) {
  const [secondsLeft, setSecondsLeft] = useState(null);
  const secondsUsedRef = useRef(0);
  const intervalRef = useRef(null);

  //  Initialize ONLY when resume time is known
  useEffect(() => {
    if (!totalSeconds || initialSeconds === null) return;

    setSecondsLeft(initialSeconds);
    secondsUsedRef.current = totalSeconds - initialSeconds;
  }, [initialSeconds, totalSeconds]);

  //  Start timer ONLY after secondsLeft is set
  useEffect(() => {
    if (secondsLeft === null) return;

    if (secondsLeft <= 0) {
      onTimeUpdate?.(totalSeconds);
      onFinish?.();
      return;
    }

    intervalRef.current = setInterval(() => {
      setSecondsLeft((prev) => {
        const newVal = prev - 1;
        const used = totalSeconds - newVal;

        if (used > secondsUsedRef.current) {
          secondsUsedRef.current = used;

          onTimeUpdate?.(used);
        }

        return newVal;
      });
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, [secondsLeft, totalSeconds, onTimeUpdate, onFinish]);

  if (secondsLeft === null) return null;

  const hours = Math.floor(secondsLeft / 3600);
  const minutes = Math.floor((secondsLeft % 3600) / 60);
  const seconds = secondsLeft % 60;

  return (
    <div className="flex gap-2">
      {[hours, minutes, seconds].map((val, i) => (
        <div
          key={i}
          className="flex flex-col items-center bg-[#fc8e11] text-white rounded-lg p-2 w-16"
        >
          <span className="text-xl font-bold">
            {String(val).padStart(2, "0")}
          </span>
          <span className="text-sm">
            {i === 0 ? "Hours" : i === 1 ? "Minutes" : "Seconds"}
          </span>
        </div>
      ))}
    </div>
  );
}
